import { Component, OnInit, EventEmitter, ViewChild, Output } from "@angular/core";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";
import { Aguas, AuxJasper, CertificadoNoAdeudoInput, ParametroJasper, SolicitudDetalles } from '../../entidades/entidades';
import { Observable, empty } from "rxjs";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { RAguasPersonas, FlujoTramitesInput } from "../../entidades/entidades";
import { Personas } from "../../entidades/entidades";
import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { Medidores } from "../../entidades/entidades";
import { MedidoresService } from "../../servicios/medidores.service";
import { CargosDetallesInput } from "../../entidades/entidades";
import { CargosDetallesService } from "../../servicios/cargos-detalles.service";
import { DatosCartoweb, DatosCartowebInput } from "../../entidades/entidades";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { AguaBuscaCuentasService } from "app/servicios/agua-busca-cuentas.service";
import { CatColoniasService } from '../../servicios/cat-colonias.service';
import { CatColonias } from '../../entidades/entidades';

import { AguasComponent } from '../../componentes/aguas/aguas.component';
import { PersonasComponent } from '../../componentes/personas/personas.component';
import { FlujoTramitesInputService } from '../../servicios/flujo-tramites.service';
import { CertificadoNoAdeudoService } from "../../servicios/certificado-no-adeudo.service";

import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-cuentas",
  templateUrl: "./cuentas.component.html",
  styleUrls: ["./cuentas.component.css"],
})
export class CuentasComponent implements OnInit {
  public aguas$: Observable<Aguas>;
  public aguasLimpio: Aguas;
  public idAguasProceso: number;
  public rAguasPersonas: RAguasPersonas;
  public personas$: Observable<Personas>;
  public personasLimpio: Personas;
  public medidores$ = new EventEmitter<Medidores>();
  public medidoresLimpio: Medidores;
  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();
  public cargosDetallesInputLimpio: CargosDetallesInput;
  public datosCartoweb: DatosCartoweb;
  public datosCartowebInput$ = new EventEmitter<DatosCartowebInput>();
  public auxJasper: AuxJasper;
  buscando: boolean = false;
  public cuentaSinModificar: Aguas;

  public personaRecibida: Personas;
  public aguasDatos: Aguas;
  public solicitud: SolicitudDetalles;

  catColonia = new CatColonias();
  catColonias: CatColonias[] = [];
  coloniasNombre: string;

  @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;

  public IdSolicitud: string;

  display: boolean = false;
  showDialog() {
    this.display = true;
  }

  datos: any;
  usuario: any;
  altaDerivada: boolean = false;

  idConceptoSolicitado: number;
  public esRectificacion: boolean = false;


  //public personas: Personas;
  muestraMensaje = new MuestraMensaje();
  @ViewChild(AguasComponent, { static: false }) childAguasComponent;
  @ViewChild(PersonasComponent, { static: false }) childPersonasComponent;

  constructor(
    private aguasService: AguasService,
    private rAguasPersonasService: RAguasPersonasService,
    private personasService: PersonasService,
    private medidoresService: MedidoresService,
    private cargosDetallesService: CargosDetallesService,
    private solicitudDetallesService: SolicitudDetallesService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService,
    private router: Router,
    private catColoniasService: CatColoniasService,
    private flujoTramitesInputService: FlujoTramitesInputService,
    private certificadoNoAdeudoService: CertificadoNoAdeudoService
  ) {
    this.aguasOutput = new EventEmitter();
  }

  ngOnInit() {
    this.catColonias = null;
    try {
      this.datos = history.state.example;
      if (this.datos) {
        this.IdSolicitud = this.datos.idSolicitud;
        console.log("this.router: ", this.datos.idSolicitud);
        this.confirmaSolicitud();
      } else {
        this.router.navigateByUrl("/");
      }
    } catch {
      this.muestraMensaje.notification(
        "No existe una solicitud Previa",
        "top",
        "center"
      );
    }
  }

  ngOnDestroy(): void { }

  async childAguaBuscaCuentas(idAgua: number) {
    try {
      this.idAguasProceso = idAgua;
      let medidoresBusquedas = new Medidores();

      if (!this.idAguasProceso) {
        this.aguas$ = await this.aguasService.getSingle(0);
        this.personas$ = await this.personasService.getSingle(0);

        medidoresBusquedas.idAgua = 0;
        this.medidores$.emit(null);
        this.cargosDetallesInput$.emit(null);
        this.datosCartowebInput$.emit(null);
        console.log("Paaso por el limpiador");
        return;
      }

      //carga formulario de agua
      this.aguas$ = await this.aguasService.getSingle(idAgua);

      //Carga formulario de personas
      const rAguasPersonasBusquedas = new RAguasPersonas();
      rAguasPersonasBusquedas.idAgua = idAgua;
      await this.getRAguasPersonas(rAguasPersonasBusquedas);
      this.personas$ = await this.personasService.getSingle(
        this.rAguasPersonas.idPersona
      );
      console.log('this.personas$ ', this.personas$);
      //Carga medidores
      const medidoresInput = new Medidores();
      medidoresInput.idAgua = idAgua;
      await this.medidores$.emit(medidoresInput);

      //Carga detalle adeudos
      let cargosDetallesInput = new CargosDetallesInput();
      cargosDetallesInput.idAgua = idAgua;
      cargosDetallesInput.idEstatus = 1;
      this.cargosDetallesInput$.emit(cargosDetallesInput);

      //Carga Carto

      let datosCartowebInput = new DatosCartowebInput();
      datosCartowebInput.idAgua = idAgua;
      console.log("IdAgua: ", datosCartowebInput.idAgua);
      this.datosCartowebInput$.emit(datosCartowebInput);
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childAguas");
    }
  }

  async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
    try {
      const datoRetorno = await this.rAguasPersonasService
        .getBusquedas(rAguasPersonas)
        .toPromise();
      this.rAguasPersonas = datoRetorno[0];
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getRAguasPersonas");
    }
  }

  async addRAguasPersonas(rAguasPersonas) {
    try {
      const datoretorno = await this.rAguasPersonasService
        .add(rAguasPersonas)
        .toPromise();
      this.rAguasPersonas = datoretorno;
      console.log("rAguasPersonas: ", datoretorno);
      this.buscando = false;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
      this.buscando = false;
    } finally {
      this.buscando = false;
      console.log("Paso por addRAguasPersonas");
    }
  }

  async guardaContrato() {

    debugger;
    this.buscando = true;
    
    //VALIDA SI EL CONCEPTO SELECCIONADO ES RECTIFICACION DE DATOS (140) O CAMBIO DE PROPIETARIO
    if (this.idConceptoSolicitado == 6 || this.idConceptoSolicitado == 7 || this.idConceptoSolicitado == 8) {
      console.log('Formulario: ', this.childAguasComponent.aguasForm.value);
      console.log('Cuenta No Modificada: ', this.cuentaSinModificar);
      // SI SE ENCUENTRA UNA MODIFICACIÓN ENTRE EL FORMULARIO DE AGUAS Y LA CUENTA RECIBIDA EN UN PRINCIPIO
      // LANZA UNA ALERTA Y RESTABLECE EL FORMULARIO DE AGUAS TAL COMO ESTABA EN UN INICIO
      if (this.childAguasComponent.aguasForm.value.cuentaAgua != this.cuentaSinModificar.cuentaAgua
        || this.childAguasComponent.aguasForm.value.cuentaAguaAnterior != this.cuentaSinModificar.cuentaAguaAnterior
        || this.childAguasComponent.aguasForm.value.cuentaPredial != this.cuentaSinModificar.cuentaPredial
        || this.childAguasComponent.aguasForm.value.cveDepto != this.cuentaSinModificar.cveDepto
        || this.childAguasComponent.aguasForm.value.cveEdif != this.cuentaSinModificar.cveEdif
        || this.childAguasComponent.aguasForm.value.cveLoc != this.cuentaSinModificar.cveLoc
        || this.childAguasComponent.aguasForm.value.cveLote != this.cuentaSinModificar.cveLote
        || this.childAguasComponent.aguasForm.value.cveManz != this.cuentaSinModificar.cveManz
        || this.childAguasComponent.aguasForm.value.cveMun != this.cuentaSinModificar.cveMun
        || this.childAguasComponent.aguasForm.value.cveZona != this.cuentaSinModificar.cveZona
        || this.childAguasComponent.aguasForm.value.derivada != this.cuentaSinModificar.derivada
        || this.childAguasComponent.aguasForm.value.domicilio != this.cuentaSinModificar.domicilio
        || this.childAguasComponent.aguasForm.value.id != this.cuentaSinModificar.id
        || this.childAguasComponent.aguasForm.value.idAguaZona != this.cuentaSinModificar.idAguaZona
        || this.childAguasComponent.aguasForm.value.idColonia != this.cuentaSinModificar.idColonia
        || this.childAguasComponent.aguasForm.value.idDiametroToma != this.cuentaSinModificar.idDiametroToma
        || this.childAguasComponent.aguasForm.value.idEstatus != this.cuentaSinModificar.idEstatus
        || this.childAguasComponent.aguasForm.value.idMunicipio != this.cuentaSinModificar.idMunicipio
        || this.childAguasComponent.aguasForm.value.idSolicitud != this.cuentaSinModificar.idSolicitudDetalle
        || this.childAguasComponent.aguasForm.value.idTipoConsumo != this.cuentaSinModificar.idTipoConsumo
        || this.childAguasComponent.aguasForm.value.idTipoGiro != this.cuentaSinModificar.idTipoGiro
        || this.childAguasComponent.aguasForm.value.idTipoPeriodoUp != this.cuentaSinModificar.idTipoPeriodoUp
        || this.childAguasComponent.aguasForm.value.idTipoServicio != this.cuentaSinModificar.idTipoServicio
        || this.childAguasComponent.aguasForm.value.idTipoToma != this.cuentaSinModificar.idTipoToma
        || this.childAguasComponent.aguasForm.value.idTipoUso != this.cuentaSinModificar.idTipoUso
        || this.childAguasComponent.aguasForm.value.observaciones != this.cuentaSinModificar.observaciones) {
        await this.muestraMensaje.error(
          "Solo se puede modificar datos del contribuyente en el servicio de Cambio de propietario.",
          "top",
          "center"
        );

        let emiteAgua = new Aguas();
        emiteAgua = this.cuentaSinModificar;

        this.aguas$ = await this.aguasService.getSingle(this.cuentaSinModificar.id);
        
        this.buscando = false;
        console.log('Entro aqui ', emiteAgua);
        return;
      }
    }

    //SI ES RECTIFICACION DE DATOS NO SE PUEDE MODIFICAL LA INFORMACIÓN DEL CLIENTE
    // if(this.idConceptoSolicitado == 140)
    // {
    //   //COMPARA LOS DATOS DE LA PERSONA CARGADA EN UN PRINCIPIO PARA REVISAR SI SE REALIZO ALGÚN CAMBIO
    //   if(  this.childPersonasComponent.personasForm.value.nombre          != this.personaRecibida.nombre
    //     || this.childPersonasComponent.personasForm.value.primerApellido  != this.personaRecibida.primerApellido
    //     || this.childPersonasComponent.personasForm.value.segundoApellido != this.personaRecibida.segundoApellido
    //     || this.childPersonasComponent.personasForm.value.razonSocial     != this.personaRecibida.razonSocial)
    //   {
    //     this.muestraMensaje.error('No puedes modificar la información del contribuyente desde la Rectificación de datos (Solo datos de la cuenta).', 'top', 'center');
    //     this.personas$ = await this.personasService.getSingle(this.personaRecibida.id);
    //     this.buscando = false;
    //     return;
    //   }
    // }

    //SI SE HACE UN CAMBIO DE TIPO DE SERVICIO Y TIENE UN ADEUDO, NO DEJARA HACER DICHO CAMBIO
    if (this.cuentaSinModificar.idTipoServicio != this.childAguasComponent.aguasForm.value.idTipoServicio
      || this.cuentaSinModificar.idTipoUso != this.childAguasComponent.aguasForm.value.idTipoUso) {
      let certificadoNoAdeudo = new CertificadoNoAdeudoInput();
      certificadoNoAdeudo.idAgua = this.cuentaSinModificar.id;
      const retornaAdeudo = await this.certificadoNoAdeudoService.getBusquedas(certificadoNoAdeudo).toPromise();
      console.log('retornaAdeudo', retornaAdeudo);
      if (!retornaAdeudo[0]) {
        this.muestraMensaje.error('No se puede realizar un cambio de tipo de servicio o tipo de uso si la cuenta tiene adeudo.', 'top', 'center');
        throw new Error("Debe seleccionar un Lecturista.");
      }
    }

    //Si no existe colonia o idAguaZona ya no hace inserción de NADA
    if (this.childAguasComponent.aguasForm.value.idAguaZona == null || this.childAguasComponent.aguasForm.value.idColonia == null) {
      await this.muestraMensaje.error(
        "Debes de seleccionar una colonia.",
        "top",
        "center"
      );
      return;
    }

    if (this.childPersonasComponent.personasForm.value.nombre == null && this.childPersonasComponent.personasForm.value.primerApellido == null
      && this.childPersonasComponent.personasForm.value.segundoApellido == null
      && this.childPersonasComponent.personasForm.value.razonSocial == null) {
      await this.muestraMensaje.error(
        "La información del contribuyente no puede ir vacía.",
        "top",
        "center"
      );
      return;
    }

    await this.childAguasComponent.guardarAguas();
    await this.childPersonasComponent.actualizaPersona();

    let rAguaPer = new RAguasPersonas;
    rAguaPer.idAgua = this.childAguasComponent.aguas.id;
    rAguaPer.idPersona = this.childPersonasComponent.personas.id;


    await this.imprimeSolicitud();

    if (this.rAguasPersonas) {
      console.log("EXISTE: ", this.rAguasPersonas);
      //await this.addContrato(this.rAguasPersonas.idAgua);
      // this.contratos.idAgua = this.rAguasPersonas.idAgua;
      // await this.addContrato(this.contratos);
      let flujoSolicitudes = new FlujoTramitesInput;
      flujoSolicitudes.idSolicitudDetalle = parseInt(this.IdSolicitud);
      flujoSolicitudes.inicio = false;
      // console.log(this.);

      await this.flujoTramitesInputService.add(flujoSolicitudes).toPromise();

      await this.getAguas(this.rAguasPersonas.idAgua);
    } else {
      await this.addRAguasPersonas(rAguaPer);
      // this.muestraMensaje.error(
      //   "NO EXISTE RELACIÓN ENTRE LA CUENTA Y LA PERSONA",
      //   "top",
      //   "center"
      // );
    }

  }

  async confirmaSolicitud() {
    try {
      const datoRetorno = await this.solicitudDetallesService.getSingle(parseInt(this.IdSolicitud)).toPromise();
      let solDetalle = new SolicitudDetalles;
      this.solicitud = datoRetorno;
      solDetalle = datoRetorno;
      this.idConceptoSolicitado = solDetalle.idConcepto;
      console.log('Solicitud Detalle: ', solDetalle);
      if (this.idConceptoSolicitado != 140) {
        console.log('Entra 1 ',);
        this.esRectificacion = false;
      } else {
        console.log('Entra 1 ',);
        this.esRectificacion = true;

      }


      if (!datoRetorno) {
        this.muestraMensaje.error("Esta solicitud no corresponde a una alta de contratos", "top", "center");
        this.router.navigateByUrl("/");
      }

      if (datoRetorno.idAgua) {
        this.getAguas(datoRetorno.idAgua);
        console.log('Manda buscar a Aguas ------>', datoRetorno.idAgua);
      }
    } catch {

    } finally {
      console.log("Paso por confirmaSolicitud");
    }

  }

  async getAguas(id: number) {
    try {
      const datoRetorno = await this.aguasService.getSingle(id).toPromise();
      let aguaR = new Aguas();
      this.aguasDatos = datoRetorno;
      console.log("datoRetorno, ", datoRetorno);

      if (datoRetorno) {
        this.cuentaSinModificar = datoRetorno;
        aguaR = datoRetorno;
        // busca datos persona 
        let rAguasPersonas = new RAguasPersonas();
        rAguasPersonas.idAgua = aguaR.id;
        console.log('Esto Manda', rAguasPersonas);
        await this.getRAguasPersonas(rAguasPersonas);
        if (this.rAguasPersonas.idPersona)
          this.getPersonas(this.rAguasPersonas.idPersona);
        console.log("Va a emitir", aguaR);
        this.aguas$ = await this.aguasService.getSingle(aguaR.id);
        this.buscando = false;
      }

    } catch (e) {
      this.buscando = false;
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      this.buscando = false;
      console.log("Paso por getAguas");

    }
  }

  async getPersonas(id: number) {
    try {

      const datoRetorno = await this.personasService.getSingle(id).toPromise();
      this.personaRecibida = datoRetorno;
      this.personas$ = await this.personasService.getSingle(id);

      const per = this.personas$;

      console.log('PERSONA: ', per);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPersonas");
    }
  }

  async imprimeSolicitud() {
    await  this.getAllCatColonias(this.aguasDatos.idColonia);
    try {
      // ejemplo de llamada de reporte.
      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.nombreReporte = "solicitud_CorrecionDatos";
      this.auxJasper.JasperReport.tipo = "pdf";
     
      // -- Parametros --

      let par_id_cuenta = new ParametroJasper();
      par_id_cuenta.nombre = "par_id_cuenta";
      par_id_cuenta.valor = this.aguasDatos.id == null ? null : this.aguasDatos.id + "";

      let par_cuenta = new ParametroJasper();
      par_cuenta.nombre = "par_cuenta";
      par_cuenta.valor = this.aguasDatos.cuentaAgua == null ? null : this.aguasDatos.cuentaAgua + "";

      let par_cuenta_anterior = new ParametroJasper();
      par_cuenta_anterior.nombre = "par_cuenta_anterior";
      par_cuenta_anterior.valor = this.aguasDatos.cuentaAguaAnterior == null ? null : this.aguasDatos.cuentaAguaAnterior;

      let par_derivada = new ParametroJasper();
      par_derivada.nombre = "par_derivada";
      par_derivada.valor = this.aguasDatos.derivada == null ? null : this.aguasDatos.derivada + "";

      let par_nombre = new ParametroJasper();
      par_nombre.nombre = "par_nombre";
      par_nombre.valor = this.personaRecibida.nombre == null ? null : this.personaRecibida.nombre +" " + this.personaRecibida.primerApellido + " "+this.personaRecibida.segundoApellido;

      let par_domicilio = new ParametroJasper();
      par_domicilio.nombre = "par_domicilio";
      par_domicilio.valor = this.aguasDatos.domicilio == null ? null : this.aguasDatos.domicilio;

      let par_mzn = new ParametroJasper();
      par_mzn.nombre = "par_mzn";
      par_mzn.valor = this.aguasDatos.cveManz == null ? null : this.aguasDatos.cveManz + " ";
      await this.auxJasper.ParametroJasper.push(par_mzn);
      
      let par_cveLote = new ParametroJasper();
      par_cveLote.nombre = "par_cveLote";
      par_cveLote.valor = this.aguasDatos.cveLote == null ? null : this.aguasDatos.cveLote + "";

      let par_numExteror = new ParametroJasper();
      par_numExteror.nombre = "par_numExteror";
      par_numExteror.valor = this.aguasDatos.numExteror == null ? null : this.aguasDatos.numExteror + "";

      let par_numInterior = new ParametroJasper();
      par_numInterior.nombre = "par_numInterior";
      par_numInterior.valor = this.aguasDatos.numInterior == null ? null : this.aguasDatos.numInterior + "";

      let par_cveEdif = new ParametroJasper();
      par_cveEdif.nombre = "par_cveEdif";
      par_cveEdif.valor = this.aguasDatos.cveEdif == null ? null : this.aguasDatos.cveEdif + "";

      let par_idAguaZona = new ParametroJasper();
      par_idAguaZona.nombre = "par_idAguaZona";
      par_idAguaZona.valor = this.aguasDatos.idAguaZona == null ? null : this.aguasDatos.idAguaZona + "";

      let par_cveDepto = new ParametroJasper();
      par_cveDepto.nombre = "par_cveDepto";
      par_cveDepto.valor = this.aguasDatos.cveDepto == null ? null : this.aguasDatos.cveDepto + "";

      let par_ccolonia = new ParametroJasper();
      par_ccolonia.nombre = "par_ccolonia";
      par_ccolonia.valor = this.coloniasNombre;


      await this.auxJasper.ParametroJasper.push(par_cveLote);
      await this.auxJasper.ParametroJasper.push(par_cuenta_anterior);
      await this.auxJasper.ParametroJasper.push(par_derivada);
      await this.auxJasper.ParametroJasper.push(par_nombre);
      await this.auxJasper.ParametroJasper.push(par_domicilio);

      await this.auxJasper.ParametroJasper.push(par_id_cuenta);
      await this.auxJasper.ParametroJasper.push(par_cuenta);
      await this.auxJasper.ParametroJasper.push(par_numExteror);
      await this.auxJasper.ParametroJasper.push(par_numInterior);
      await this.auxJasper.ParametroJasper.push(par_cveEdif);
      await this.auxJasper.ParametroJasper.push(par_idAguaZona);
      await this.auxJasper.ParametroJasper.push(par_cveDepto);
      await this.auxJasper.ParametroJasper.push(par_ccolonia);

      await this.showDialog();
    } catch {
      await this.muestraMensaje.error(
        "No existe registro del Contrato",
        "top",
        "center"
      );
    }
  }

  async getAllCatColonias(id: number) {
    try {
      const datoRetorno = await this.catColoniasService.getAll().toPromise();
      this.catColonias = datoRetorno;
      
      for (let index = 0; index < Object.keys(this.catColonias).length; index++) {
       if (this.catColonias[index].id == id){
         this.coloniasNombre = this.catColonias[index].descripcion;
       }  
      }  
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log('Paso por getCatColonias');
    }
  }



}
